<div
  class="announcement-bar"
  [class.announcement-bar--visible]="visible()"
  [class.announcement-bar--animated]="animated()"
  role="region"
  aria-label="Get your free plan"
>
  <a
    class="announcement-bar__link"
    href="#get-a-call"
    appQuoteCta="announcement_bar"
  >
    Receive Your Personalized Medical Plan for Free
  </a>
</div>
